import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-77ba2f83"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ui-df__anim"
}
const _hoisted_2 = { class: "ui-df__elm-selected" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 1,
  class: "ui-df__list"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-df__list-line" }, null, -1))
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconSearch = _resolveComponent("IconSearch")!
  const _component_IconChevronDown = _resolveComponent("IconChevronDown")!

  return (_openBlock(), _createElementBlock("div", {
    class: "ui-df",
    onFocusout: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocusOut && _ctx.onFocusOut(...args))),
    tabindex: "0"
  }, [
    (_ctx.selectItem !== _ctx.SELECTED.EMPTY && _ctx.selectItem !== _ctx.SELECTED.ALL)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "ui-df__elm",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isShowIcon)
          ? (_openBlock(), _createBlock(_component_IconSearch, {
              key: 0,
              class: "ui-df__elm-selected-icon",
              color: "rgb(119, 121, 124)",
              width: "16",
              height: "16"
            }))
          : _createCommentVNode("", true),
        (
						_ctx.selectItem === _ctx.SELECTED.EMPTY ||
						_ctx.selectItem === _ctx.SELECTED.ALL
					)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.label), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.selectItem), 1))
      ]),
      _createVNode(_component_IconChevronDown)
    ]),
    (_ctx.isShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "ui-df__list-item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickSelect('all', 0)))
          }, _toDisplayString(_ctx.dropdownDefaultLabel), 1),
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (_ctx.onClickSelect(item.name, item.id)),
              class: "ui-df__list-item",
              key: index
            }, _toDisplayString(item.name), 9, _hoisted_7))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 32))
}